import { useContext } from 'react';
import styled from 'styled-components';
import { Input } from 'reactstrap';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import { captureEvent } from '../../utils/analytics';

// This container and the CheckboxLabel below are used to provide a larger
// click target for the checkbox without changing its size or appearance.
const CheckboxContainer = styled.div`
  position: relative;
  width: 25px;
  height: 25px;
  margin: -5px;
`;

const CheckboxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
`;

const CheckboxInput = styled(Input)`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

const MultiSelectCheckbox = ({
  checkboxEnabled, // When false, calls renderDefault regardless of isHovered
  id,
  isHovered,
  multiSelectMapMode, // Map mode to set on click
  onSelected,
  renderDefault, // What to render if the checkbox is not shown
  selectedMapModes, // Valid map modes for the checkbox to be selected
  selectedIds,
}) => {
  const {
    mapState: { mapMode, setMapMode },
  } = useContext(MapContext);

  const isSelected = selectedMapModes.includes(mapMode) && selectedIds.has(id);

  const onClick = (e) => {
    e.stopPropagation();
    if (!isSelected && onSelected) {
      onSelected();
      captureEvent('multi-section-select', { count: selectedIds.size });
    }
  };

  const onSelect = () => {
    setMapMode(multiSelectMapMode, id);
  };

  return checkboxEnabled && (isHovered || isSelected) ? (
    <CheckboxContainer>
      <CheckboxInput
        id={`multiselect-checkbox-${id}`}
        type="checkbox"
        checked={isSelected}
        onChange={onSelect}
        onClick={onClick}
        className="fs-multiselect-checkbox"
      />
      <CheckboxLabel htmlFor={`multiselect-checkbox-${id}`} onClick={onClick} />
    </CheckboxContainer>
  ) : (
    renderDefault()
  );
};

export default MultiSelectCheckbox;

export const MultiSelectSectionCheckbox = (props) => {
  const {
    mapState: { selectedFieldIds },
  } = useContext(MapContext);
  return (
    <MultiSelectCheckbox
      multiSelectMapMode={mapModes.MULTI_SECTION_SELECT}
      selectedMapModes={[
        mapModes.MULTI_SECTION_SELECT,
        mapModes.SECTION_GROUP_ENGAGED,
      ]}
      selectedIds={selectedFieldIds}
      {...props}
    />
  );
};

export const MultiSelectLayerFeatureCheckbox = (props) => {
  const {
    mapState: { selectedLayerFeatureIds },
  } = useContext(MapContext);
  return (
    <MultiSelectCheckbox
      multiSelectMapMode={mapModes.MULTI_LAYER_FEATURE_SELECT}
      selectedMapModes={[mapModes.MULTI_LAYER_FEATURE_SELECT]}
      selectedIds={selectedLayerFeatureIds}
      {...props}
    />
  );
};
